import dayjs from "dayjs";

export const formatTableDateTime = (
  date: string | Date | null | undefined,
): string => {
  if (date == null) {
    return "N/A";
  }
  const d = dayjs(date);
  return d.isValid() ? d.format("YYYY-MM-DD hh:mm:ss A") : "N/A";
};
